<template>
    <div class="intellectual">
        <div class="content-container">
            <div class="content">
                <h1 class="page-title">知识产权保护</h1>
                <p>如果您发现第三方存在侵犯魔力玛特依法享有的知识产权的情况（例如：生产、销售盗版或山寨、未经授权使用IP形象进行推广宣传等），请您通过以下方式与我们联系，告知相关的信息。</p>
                <p class="tip">如涉及中国大陆地区的侵权举报或授权验证，请联系邮箱：hanfeifei@baikewan.com</p>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'IntellectualPage',
    components: {

    }
}
</script>

<style scoped>
.intellectual {
    min-height: 93vh;
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
}

.content-container {
    flex: 1;
    width: 100%;
}

.content-container p {
    font-weight: 500;
    font-size: 19px;
    color: #1A1A1A;
    max-width: 1213px;
    margin: 0 auto;
}

.page-title {
    font-weight: 800;
    font-size: 48px;
    color: #1B1B1B;
    text-align: center;
    margin-bottom: 115px;
    margin-top: 162px;
}

.tip {
    padding-top: 80px;
}
</style>
